import { render, staticRenderFns } from "./MainLoyalty.vue?vue&type=template&id=5b6f4546&scoped=true&"
import script from "./MainLoyalty.vue?vue&type=script&lang=js&"
export * from "./MainLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./MainLoyalty.vue?vue&type=style&index=0&id=5b6f4546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f4546",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VRow})
